import { gql } from '@apollo/client';

// 관리자 내 정보 조회
export const SEE_MY_ADMIN_INFO = gql`
    query SeeMyAdminInfo {
        seeMyAdminInfo {
            adminId
            createdAt
            updatedAt
            master
            account
            name
            rank
            cellphone
            memo
            passwordInit
            pwUpdateDate
            latestLogin
            adminPermission {
                apId
                dashboard
                user
                product
                management
            }
        }
    }
`;

// // 대시보드
// export const SEE_DASHBOARD = gql``;

// 회원 관리 > 회원 목록
export const SEE_USER_LIST = gql`
    query SeeUserList(
        $orderBy: Int!
        $searchTerm: String!
        $take: Int!
        $preCursor: Int!
        $nextCursor: Int!
        $cursorOption: Boolean
    ) {
        seeUserList(
            orderBy: $orderBy
            searchTerm: $searchTerm
            take: $take
            preCursor: $preCursor
            nextCursor: $nextCursor
            cursorOption: $cursorOption
        ) {
            totalLength
            userList {
                userId
                uniqueKeyId
                createdAt
                email
                name
                cellphone
                snsType
                qrCount
            }
        }
    }
`;
// 회원 관리 > 회원 상세
export const SEE_USER_DETAIL = gql`
    query SeeUserDetail($userId: Int!) {
        seeUserDetail(userId: $userId) {
            userId
            uniqueKeyId
            createdAt
            email
            name
            cellphone
            snsType
            qrCount
            pet {
                petId
                createdAt
                updatedAt
                petNickName
                name
                birth
                regNum
                img
                status
                isOwner
                qrNum
                sharedUsers {
                    suId
                    createdAt
                    updatedAt
                    cellphone
                    nickName
                    regStatus
                    shared
                }
            }
        }
    }
`;
// 회원 상세 > 공유자 정보
export const SEE_SHARED_USER_LIST = gql`
    query SeeSharedUserList($petId: Int!) {
        seeSharedUserList(petId: $petId) {
            suId
            createdAt
            updatedAt
            cellphone
            nickName
            regStatus
            shared
        }
    }
`;

// 운영 > QR 목록
export const SEE_PET_QR_LIST = gql`
    query SeePetQrList(
        $orderBy: Int!
        $searchTerm: String!
        $take: Int!
        $preCursor: Int!
        $nextCursor: Int!
        $cursorOption: Boolean
    ) {
        seePetQrList(
            orderBy: $orderBy
            searchTerm: $searchTerm
            take: $take
            preCursor: $preCursor
            nextCursor: $nextCursor
            cursorOption: $cursorOption
        ) {
            totalLength
            petQrList {
                qrId
                createSequenct
                qrNum
                regDate
                ownerName
                ownerCellphone
                ownerEmail
                petRegNum
                subs
                subsStart
                subsEnd
            }
        }
    }
`;
// 운영 > 상품 조회
export const SEE_PRODUCT_LIST = gql`
    query SeeProductList(
        $orderBy: Int!
        $searchTerm: String!
        $take: Int!
        $preCursor: Int!
        $nextCursor: Int!
        $cursorOption: Boolean
    ) {
        seeProductList(
            orderBy: $orderBy
            searchTerm: $searchTerm
            take: $take
            preCursor: $preCursor
            nextCursor: $nextCursor
            cursorOption: $cursorOption
        ) {
            totalLength
            productList {
                prId
                createdAt
                name
                url
                price
                img
                accClickCount
                lastMonthClickCount
            }
        }
    }
`;
// 운영 > 방침 조회
export const SEE_POLICY_LIST = gql`
    query SeePolicyList(
        $type: Int!
        $orderBy: Int!
        $searchTerm: String!
        $take: Int!
        $preCursor: Int!
        $nextCursor: Int!
        $cursorOption: Boolean
    ) {
        seePolicyList(
            type: $type
            orderBy: $orderBy
            searchTerm: $searchTerm
            take: $take
            preCursor: $preCursor
            nextCursor: $nextCursor
            cursorOption: $cursorOption
        ) {
            totalLength
            policyList {
                pcyId
                createdAt
                type
                require
                title
                text
                creatorId
                creatorName
                creatorRank
            }
        }
    }
`;

// 설정 > QR 리스트
export const SEE_CREATED_QR_LIST = gql`
    query SeeCreatedQrList(
        $orderBy: Int!
        $take: Int!
        $preCursor: Int!
        $nextCursor: Int!
        $cursorOption: Boolean
    ) {
        seeCreatedQrList(
            orderBy: $orderBy
            take: $take
            preCursor: $preCursor
            nextCursor: $nextCursor
            cursorOption: $cursorOption
        ) {
            totalLength
            QRCreateSequenceList {
                qrcsId
                createdAt
                amount
                usedAmount
                unUsedAmount
                usedRatio
                zipImgUrl
            }
        }
    }
`;
// 설정 > 운영자 목록
export const SEE_ADMIN_LIST = gql`
    query SeeAdminList(
        $orderBy: Int!
        $searchTerm: String!
        $take: Int!
        $preCursor: Int!
        $nextCursor: Int!
        $cursorOption: Boolean
    ) {
        seeAdminList(
            orderBy: $orderBy
            searchTerm: $searchTerm
            take: $take
            preCursor: $preCursor
            nextCursor: $nextCursor
            cursorOption: $cursorOption
        ) {
            totalLength
            adminList {
                adminId
                createdAt
                updatedAt
                master
                account
                name
                rank
                cellphone
                memo
                passwordInit
                pwUpdateDate
                latestLogin
                adminPermission {
                    apId
                    dashboard
                    user
                    product
                    management
                }
            }
        }
    }
`;
// 설정 > 운영자 상세
export const SEE_ADMIN_DETAIL = gql`
    query SeeAdminDetail($adminId: Int!) {
        seeAdminDetail(adminId: $adminId) {
            adminId
            createdAt
            updatedAt
            master
            account
            name
            rank
            cellphone
            memo
            passwordInit
            pwUpdateDate
            latestLogin
            adminPermission {
                apId
                dashboard
                user
                product
                management
            }
        }
    }
`;
// 설정 > 시스템 로그
export const SEE_SYSTEM_HISTORY_LIST = gql`
    query SeeSystemHistoryList(
        $orderBy: Int!
        $type: Int!
        $searchStart: String!
        $searchEnd: String!
        $searchTerm: String!
        $take: Int!
        $preCursor: Int!
        $nextCursor: Int!
        $cursorOption: Boolean
    ) {
        seeSystemHistoryList(
            orderBy: $orderBy
            type: $type
            searchStart: $searchStart
            searchEnd: $searchEnd
            searchTerm: $searchTerm
            take: $take
            preCursor: $preCursor
            nextCursor: $nextCursor
            cursorOption: $cursorOption
        ) {
            totalLength
            adminLogList {
                alId
                createdAt
                type
                name
                rank
                text
            }
        }
    }
`;
